import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="auth">
      <Link to="/" className="auth__brand">LotSmith</Link>
      <div className="auth__card">
        <h1>404</h1>
        <p className="auth__lead">This page doesn&rsquo;t exist.</p>
        <Link to="/" className="btn btn--primary btn--block">Go home</Link>
      </div>
    </div>
  );
}
